import React from "react";
import Component from "../../Components";
import "./NurseRequest.css";

const ApprovedRequestDetailsPage = () => {
  return (
    <div className="mng-nurse-req">
      <Component.ApprovedRequestDetails />
    </div>
  );
};

export default ApprovedRequestDetailsPage;
